import React from "react";
import { Outlet } from "react-router-dom";
import PlatformHeader from "./components/header/header";
import PlatformFooter from "./components/footer/footer";
import SideDrawer from "./components/sideDrawer/sideDrawer";
import "./app.scss";
import { WebViewUserAgent } from "./utils/ApiConstants";
import { Layout } from 'antd';

const { Header, Sider, Content } = Layout;

interface Props {
  showSideDrawer: boolean;
  isShowSideDrawer: (value: any) => void;
  visible: boolean;
  setVisible: (val: any) => void;
  setIsDarkMode?: any;
  darkMode?: boolean;
}

const PlatformLayout: React.FC<Props> = ({
  showSideDrawer,
  isShowSideDrawer,
  visible,
  setVisible
}) => {


  const userAgent = navigator.userAgent || "";

  //If user agent is same as web view agent - page is opened in mobile app webview - do not show header and side menu
  if (userAgent.includes(WebViewUserAgent)) {
    return (
      <div className="container">

        <div className="main-area mt-1 h-100" style={{ top: 0 }}>
          <div className="right-area ml-0">
            <Outlet />
          </div>
        </div>
      </div>
    );

  } else {
    return (

      <Layout style={{ height: "100vh" }}>
        <Header className="px-0 platform-header">
          
          <PlatformHeader
            showSideDrawer={showSideDrawer}
            isShowSideDrawer={(value: any) => isShowSideDrawer(value)}
          ></PlatformHeader>

        </Header>

        <Layout style={{ height: "100vh" }}>


          <Sider className="side-drawer bg-white" breakpoint="lg" 
            trigger={null}
            collapsedWidth="50"
            width={"225"}
            collapsible={true}
            collapsed={visible}
          >
            <SideDrawer
              visible={showSideDrawer}
              setVisible={(val: any) => setVisible(val)}
              isShowSideDrawer={(value: any) => isShowSideDrawer(value)}
            />
          </Sider>
          <Layout style={{ height: "100%" }}>


            <Content className="ml-2" style={{ overflow: "auto" }}>
              <Outlet />
            </Content>
            <PlatformFooter />
          </Layout>


        </Layout>
      </Layout>


    );
  }

};

export default PlatformLayout;
